<template>
<div class="chapter">
<div class="inner_page">
<h2 id="heading_id_2">Part One<br/>
   <br/>
  The Me-Centered Self</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PartOne.vue?7036ff2f